import { AccordionBody, AccordionItem, CheckboxControl } from "@dgs/core";
import styled from "styled-components";

export const FilterCheckbox = styled(CheckboxControl)`
	margin: 0 0 ${({ theme }) => theme.spacing(1)} 0;
`;

export const FilterAccordionBody = styled(AccordionBody)`
	margin: 0 0 0 ${({ theme }) => theme.spacing(3)};
	border: none;
	padding-top: ${({ theme }) => theme.spacing(1)};
	padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const FilterAccordionItem = styled(AccordionItem)`
	border-bottom: 1px solid ${({ theme }) => theme.colors.card.background.outline};
	border-radius: 0;
	padding-left: ${({ theme }) => theme.spacing(4)};
	padding-right: ${({ theme }) => theme.spacing(4)};

	& > button {
		border: none;

		> span:first-child {
			padding-left: ${({ theme }) => theme.spacing(1)};
			padding-right: ${({ theme }) => theme.spacing(1)};
		}
	}

	& > button:focus {
		border: none;
	}
`;
